// Client resolves 400s and resolves undefined on 401, so a load can fail without throwing.
export const isFailedResponse = (response: unknown): boolean =>
    !response || Number((response as { status?: unknown }).status) >= 400;
